export enum Gender {
    BOY = 'boy',
    GIRL = 'girl'
}
